/* @flow */
import Raven from "raven-js";
// The server responds with different error formats depending on the source, such
// as backstage options, error keys, arrays, etc. We always use them as
// Array<{errorMessage: string}>
export type ServerError = { errorMessage: ?string };

function warnUnparseableError(badError: any, context?: any): void {
  // We don't recognize this as an error message. Tell Sentry and bail.
  Raven.captureMessage("Received unparseable errors from server.", {
    level: "warning",
    extra: {
      providedError: badError,
      context,
    },
  });
}

export default function formatServerErrors(
  errors: any,
  context?: any
): Array<ServerError> {
  if (typeof errors === "string") {
    return [{ errorMessage: errors }];
  }
  if (!Array.isArray(errors)) {
    warnUnparseableError(errors, context);
    return [];
  }
  return errors
    .map((error) => {
      if (typeof error === "string") {
        return { errorMessage: error };
      }
      if (typeof error.message === "string") {
        const { message, ...rest } = error;
        return { errorMessage: message, ...rest };
      }
      if (typeof error.errorMessage === "string") {
        return { ...error };
      }
      warnUnparseableError(error, context);
      return null;
    })
    .filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/formatServerErrors.js